import type { RouteFilters } from '@models/route'
import { keyToUrl } from '@tools/common'
import { omit } from 'lodash'

export const routesKeys = {
  root: ['routes'],
  list: (filters?: RouteFilters) =>
    [
      ...routesKeys.root,
      omit(filters, ['page', 'limit']),
      { page: filters?.page, limit: filters?.limit },
    ] as const,
  finishRoute: (routeId: number) =>
    [...routesKeys.root, routeId, 'finish'] as const,
  unfinishRoute: (routeId: number) =>
    [...routesKeys.root, routeId, 'unfinish'] as const,
  processPlan: () => [...routesKeys.root, 'process'] as const,
  stops: (routeId: number) => [...routesKeys.root, routeId, 'stops'] as const,
}

export const routesUrls = {
  root: keyToUrl(routesKeys.list()),
  finishRoute: (routeId: number) => keyToUrl(routesKeys.finishRoute(routeId)),
  unfinishRoute: (routeId: number) =>
    keyToUrl(routesKeys.unfinishRoute(routeId)),
  processPlan: keyToUrl(routesKeys.processPlan()),
  stops: (routeId: number) => keyToUrl(routesKeys.stops(routeId)),
}
